import React from 'react'
import type { FC } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import { Typography } from '@homeviews/analytics'

const useStyles = makeStyles((theme) =>
  createStyles({
    table: {
      width: '100%',
      backgroundColor: 'white',
      marginBottom: '16px',
      borderCollapse: 'collapse',
      '& thead tr': {
        backgroundColor: theme.colors.grey200,
      },
      '& tr, & th': {
        border: `solid 1px ${theme.colors.grey250}`,
      },
      '& tr td:first-of-type': {
        borderRight: `solid 1px ${theme.colors.grey250}`,
      },
      '& td, & th': {
        height: '38px',
        paddingLeft: '24px',
        textAlign: 'left',
      },
    },
    whiteTopBorder: {
      borderTop: `solid 1px white`,
    },
    customBody2Th: {
      '.MuiTypography-body2&': {
        fontSize: '12px',
        fontWeight: 700,
        color: theme.colors.grey600,
      },
    },
    customBody2Td: {
      '.MuiTypography-body2&': {
        fontSize: '14px',
      },
    },
  }),
)

type TableProps = {
  columns: string[]
  rows: Array<string[]>
}

export const Table: FC<TableProps> = ({ columns, rows }) => {
  const classes = useStyles()

  // Only show Table if there's any row data to show
  if (!rows || rows.length === 0 || (rows[0] && rows[0].length === 0))
    return null

  return (
    <table className={classes.table}>
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th key={`${index}_${column}`}>
              <Typography variant="body2" className={classes.customBody2Th}>
                {column}
              </Typography>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, rowIndex) => (
          <tr key={`${rowIndex}_${row[0]}`}>
            {row.map((value, cellIndex) => {
              // When first cell (C1), and there's a previousRow,
              // and previousRowC1 is equivalent to currentRowC1,
              // then visually 'merge' cells by hiding top-border and value.
              let className = ''
              let displayValue = value
              const previousRow = rows[rowIndex - 1]
              if (
                cellIndex === 0 &&
                previousRow &&
                value === previousRow[cellIndex]
              ) {
                className = classes.whiteTopBorder
                displayValue = ''
              }
              return (
                <td key={`${cellIndex}_${value}`} className={className}>
                  <Typography variant="body2" className={classes.customBody2Td}>
                    {displayValue}
                  </Typography>
                </td>
              )
            })}
          </tr>
        ))}
      </tbody>
    </table>
  )
}
